import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DataActions } from "@app/project/store/actions";
import { DataServiceError } from "@app/shared/services/data-service-error";
import { LocalizerService } from "@app/shared/services/localization/localizer.service";
import { Actions, createEffect, ofType, ROOT_EFFECTS_INIT } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { catchError, map, switchMap, tap } from "rxjs/operators";
import * as LocalizerActions from "../actions/localizer.actions";

@Injectable()
export class LocalizerEffects {
    get$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(ROOT_EFFECTS_INIT),
            map(({ lang }) => {
                const _lang: string = lang || LocalizerService.supportedLanguage;
                return _lang !== "en" && _lang !== "" ? `-${_lang}` : ``;
            }),
            switchMap(lang =>
                DataActions.toAction2()(
                    this.httpClient.get(`/locale-dynamic/localized-data${lang}.json`).pipe(
                        tap(data => {
                            LocalizerService.loadedTranslations = data;
                        })
                    ),
                    LocalizerActions.getSuccess,
                    LocalizerActions.getFailure
                )
            ),
            catchError((e: DataServiceError<LocalizerActions.ActionPayload>) => of(LocalizerActions.getFailure(e)))
        )
    );

    constructor(private readonly actions$: Actions, private readonly httpClient: HttpClient) {}
}
